import { InputAnimatedLabel } from '@web/components/ui/input-animated-label';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@web/components/ui/dropdown-menu';
import { ChevronDownIcon } from 'lucide-react';

type ProcedureRiskLevelDropdownProps = {
  value?: string;
  readOnly?: boolean;
  onSelect: (risklevel: 'Low' | 'Medium' | 'High') => void;
};

export function ProcedureRiskLevelDropdown({
  value,
  readOnly = true,
  onSelect,
}: ProcedureRiskLevelDropdownProps) {
  const risklevelOptions: ('Low' | 'Medium' | 'High')[] = ['Low', 'Medium', 'High'];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild disabled={readOnly}>
        <div className="relative w-full">
          <InputAnimatedLabel
            label="RiskLevel"
            value={value ?? ''}
            readOnly={true}
            className={readOnly ? '' : 'border-2 border-blue-500'}
          />
          {!readOnly && (
            <ChevronDownIcon className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-500" />
          )}
        </div>
      </DropdownMenuTrigger>
      {!readOnly && (
        <DropdownMenuContent className="rounded-lg border bg-white shadow-lg">
          {risklevelOptions.map((risklevel) => (
            <DropdownMenuItem
              key={risklevel}
              onSelect={() => {
                onSelect(risklevel);
              }}
              className="cursor-pointer px-4 py-2 hover:bg-gray-100"
            >
              {risklevel}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      )}
    </DropdownMenu>
  );
}
